import { Badge } from "@/components/ui/badge";
import { Card, CardContent } from "@/components/ui/card";

import {
  describeMachineReason,
  describeProposalStage,
  type MachineProposal,
} from "../data/cockpit-data";
import { stageBadgeVariant } from "../format";

/**
 * One thing the machine is holding steady — a read-only audit row.
 *
 * "No action needed" is stated on every card rather than implied by the absence
 * of buttons. A card with nothing to click reads as a card that has not loaded
 * its controls yet; saying it is the whole point of the Maintain tab.
 */
export function MaintainCard({ proposal }: { proposal: MachineProposal }) {
  const stage = describeProposalStage(proposal);
  const explained = describeMachineReason(proposal.reason);
  const reason = explained
    ? `${explained.purpose ? `${explained.purpose}: ` : ""}${explained.summary}`
    : null;
  const facts = [proposal.action_type, proposal.market, proposal.keyword].filter(Boolean).join(" · ");

  return (
    <Card>
      <CardContent className="flex flex-col gap-2">
        <div className="flex flex-wrap items-center justify-between gap-2">
          <Badge variant={stageBadgeVariant(stage.tone)}>{stage.label}</Badge>
          <span className="text-xs text-muted-foreground">No action needed</span>
        </div>
        <h3 className="text-[15px] font-semibold text-ks-ink">
          {proposal.recommended_target ?? "Maintain strategy"}
        </h3>
        {facts && <p className="text-xs text-muted-foreground">{facts}</p>}
        {reason && <p className="text-[13px] text-muted-foreground">{reason}</p>}
        {proposal.units_effect && (
          <p className="text-[13px] font-medium tabular-nums text-ks-ink">{proposal.units_effect}</p>
        )}
      </CardContent>
    </Card>
  );
}
